import { render, staticRenderFns } from "./DictExportedLog.vue?vue&type=template&id=c52b24a0"
import script from "./DictExportedLog.vue?vue&type=script&lang=js"
export * from "./DictExportedLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports